import { cn } from "@utils/tw"
import { usePageContext } from "../../contexts/PageContext"
import { createContext, useEffect } from "react"
import { useHydrating } from "eddev/routing"

export const THEMES = {
  none: {
    bg: "none",
    fg: "var(--color-black)",
  },
  white: {
    bg: "var(--color-white)",
    fg: "var(--color-black)",
  },
  whiteLight: {
    bg: "var(--color-whiteLight)",
    fg: "var(--color-black)",
  },
  black: {
    bg: "var(--color-black)",
    fg: "var(--color-white)",
  },
  brick: {
    bg: "var(--color-brick)",
    fg: "var(--color-white)",
  },
  olive: {
    bg: "var(--color-olive)",
    fg: "var(--color-white)",
  },
  navy: {
    bg: "var(--color-navy)",
    fg: "var(--color-white)",
  },
  red: {
    bg: "var(--color-red)",
    fg: "var(--color-white)",
  },
  blue: {
    bg: "var(--color-blue)",
    fg: "var(--color-black)",
  },
  green: {
    bg: "var(--color-green)",
    fg: "var(--color-black)",
  },
  bark: {
    bg: "var(--color-bark)",
    fg: "var(--color-black)",
  },
  orange: {
    bg: "var(--color-orange)",
    fg: "var(--color-black)",
  },
  whiteDark: {
    bg: "var(--color-whiteDark)",
    fg: "var(--color-black)",
  },
}

export type ThemeName = keyof typeof THEMES

export const ThemedContext = createContext<{ buttonVariant: "primary" | "light" }>({ buttonVariant: "primary" })

export const Themed = ({
  theme,
  children,
  className,
  page,
  footer,
  footerTheme,
  style = {},
}: {
  theme: ThemeName | undefined | null
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  page?: boolean
  footer?: boolean
  footerTheme?: ThemeName | null | undefined
}) => {
  const hydrating = useHydrating()
  const pageContext = usePageContext()
  const currentTheme = THEMES[theme ?? "none"] || THEMES.none
  const buttonVariant = ["black", "brick", "olive", "navy", "red"].includes(theme || "") ? "light" : "primary"

  useEffect(() => {
    if (page) {
      pageContext.setTheme?.(theme ?? "none")
      // console.log("Set page theme to:", theme)
    }
    if (footer) {
      pageContext.setFooterTheme?.(footerTheme ?? "none")
      // console.log("Set footer theme to:", footerTheme)
    }
  }, [page, theme, footer, footerTheme])

  return (
    <ThemedContext.Provider value={{ buttonVariant }}>
      <div
        className={cn("themed-container", className)}
        style={
          {
            ...style,
            "--theme-bg": `rgb(${currentTheme.bg})`,
            "--theme-fg": `rgb(${currentTheme.fg})`,
          } as React.CSSProperties & Record<string, string>
        }
      >
        {children}
      </div>
    </ThemedContext.Provider>
  )
}
